import { render, staticRenderFns } from "./HandlerFilter.vue?vue&type=template&id=1068c28b&scoped=true&"
import script from "./HandlerFilter.vue?vue&type=script&lang=js&"
export * from "./HandlerFilter.vue?vue&type=script&lang=js&"
import style0 from "./HandlerFilter.vue?vue&type=style&index=0&id=1068c28b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1068c28b",
  null
  
)

export default component.exports